import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCard"><Path d="M4.5 2.5H19.5V21.5H4.5V2.5Z" stroke="currentColor"/><Circle cx="12" cy="9" r="2.5" stroke="currentColor"/><Path d="M8 14.5H16" stroke="currentColor"/><Path d="M8 17.5H16" stroke="currentColor"/></CentralIconBase>;
});

export default IconCard;
